<template>
  <el-drawer
    class="dialog-box"
    :title="title"
    v-if="showFlag"
    :visible.sync="showFlag"
    size="80%"
    :close-on-press-escape="false"
  >
    <div>
      <div class="main-wrap">
        <div class="top-title">
          <div
            :class="
              detail.orderStatus == 'TO_SEND' ||
              detail.orderStatus == 'TO_REVIEW'
                ? 'title yellow-text'
                : 'title'
            "
          >
            {{ detail.orderStatusDesc }}
          </div>
          <div class="marLeft20">订单编号：{{ detail.orderNo }}</div>
          <div class="marLeft20">下单时间：{{ detail.orderTime }}</div>
          <div class="marLeft20">订单渠道：{{ detail.sourceChannelDesc }}</div>
           <div class="marLeft20 log-btn" @click="getLogList">订单操作日志</div>
        </div>
        <div class="bot-content">
          <div class="detail-info">
            <div class="lf item">
              <div class="title line">收货信息</div>
              <div class="content">
                <div class="">
                  收货人:
                  
                  <span>{{ detail.receiveName }}</span>
                </div>
                <div>
                  联系方式:
                  
                  <span >{{ detail.receivePhone }}</span>
                </div>
                <div style="display: flex">
                  <span
                    style="margin-right: 5px"
                    >收货地址:
                  </span>
                  <span style="flex: 1;">{{ detail.addressAll }}</span>
                </div>
                <div v-if="detail.sendWs">
                  发货仓:
                  <span>{{ detail.sendWs }}-{{detail.sendLoc}}</span>
                </div>

                <div v-if="detail.express&&detail.transportNo">
                   快递/物流:{{detail.express}}{{detail.transportNo}}
                </div>



              </div>
            </div>
            <div class="lf item">
              <div class="title">买家信息</div>
              <div class="content">
                <div>买家名称: {{ detail.buyerName }}</div>
                <div>买家类型: {{ detail.buyerType }}</div>
                <div>买家留言: {{ detail.buyerRemark }}</div>
              </div>
            </div>
            <div class="rt item">
              <div class="title">其他信息</div>
              <div class="content">
                <div>需求部门: {{ detailInfo.fromDepart }}</div>
                <div>需求人员: {{ detailInfo.fromUser }}</div>
                <div>线下PI号: {{ detailInfo.piNo }}</div>
                <div>主体信息: {{ detail.bodyName }}</div>
              </div>
            </div>
          </div>
          <!-- 支付方式 -->
          <div class="sale-remark">
            <div class="label">支付信息</div>
          </div>
          <div class="detail-info">
            <div
              class="mid item large"
              style="min-height: 80px"
              v-if="!detail.payRecords && (!detail.payPics || !detail.payPics.length)"
            >
              暂无数据
            </div>
            <div class="mid item large" v-else>
              <div class="title line end">
                <div
                  v-if="detail.payPics && detail.payPics.length"
                  class="btn"
                  @click="payPicsShow = true"
                >
                  查看支付凭证
                </div>
              </div>
              <div class="pay-list">
                <div
                  class="content pay-content"
                  v-for="(item, index) in detail.payRecords"
                  :key="index"
                >
                  <div class="width20">{{ index + 1 }}</div>
                  <div class="width50">
                    {{ item.onlinePay ? "线上支付" : "手工支付" }}
                  </div>
                  <div class="width400">初始单号：{{ detail.orderNo }}</div>
                  <div class="width200">
                    实付金额:
                    {{ item.payPrice | currencyFormat(2, false, currencyShow) }}
                  </div>
                  <div class="width150">支付方式: {{ item.payTypeDesc }}</div>
                  <div class="width200">支付时间: {{ item.payTime }}</div>
                  <div class="width400">支付单号：{{ item.payNo || "" }}</div>
               
                </div>
              </div>
            </div>
          </div>
          <div class="sku-info">
            <div class="label">订单商品信息</div>
            <skuList
              :orderNo="orderNo"
              :skuData.sync="detail.skuItems"
              :payTypeListaaa="detail.payRecords"
              ref="skuItem"
              :billSource="detail.billSource"
              :buyer="detail.buyer"
              :bodyId="detail.bodyId"
              :newOrder="false"
              @getAddPayList="getAddPayList"
              @gatdatadescc="getData"
              @getSellerRemark="getSellerRemark"
              @getAmountInfo="getAmountInfo"
              @getReceiveInfo="getReceiveInfo"
              @updateCurrency="updateCurrency"
            ></skuList>
          </div>

           <div class="sale-remark">
            <div class="label">卖家备注</div>
            <vs-input
              v-model="detail.sellerRemark"
              class="w-full"
              placeholder="请输入卖家备注"
            />
          </div>
        </div>
      </div>

      <el-dialog
      title="支付凭证查看"
      :visible.sync="payPicsShow"
      append-to-body
      width="50%"
    >
      <el-image
        v-for="(url, index) in detail.payPics"
        style="width: 100px; height: 100px"
        :src="url"
        :key="index"
        :preview-src-list="detail.payPics"
      >
      </el-image>
    </el-dialog>

     <el-dialog
        class="dia-box"
        :append-to-body="true"
        title="操作日志"
        :visible.sync="isShowLogList"
        width="60%"
      >
        <div class="my-box">
          <div>
            <el-table :data="logList" style="width: 100%" height="300px">
              <el-table-column prop="optUser" label="操作人" width="180">
              </el-table-column>
              <el-table-column prop="optTime" label="操作时间" width="180">
              </el-table-column>
              <el-table-column prop="optDetail" label="操作内容">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>

    </div>
  </el-drawer>
</template>

<script>
import { OrderApi } from "@/modules/server-api/commodity-sys/order";
  import skuList from "./skuList";
import { $busErrorCode } from "@/modules/commodity-sys/common.js";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  props:{
    title:{
      type:String,
    }
  },
  components: {skuList},

  computed: {},
  data() {
    return {
      payPicsShow: false,
      showFlag: false, //订单详情弹出框
      detail: {},
      detailInfo:{},
      currencyShow: "",
      orderNo:'',
      isShowLogList:false, //操作记录
      logList:[],
  

    };
  },
  mounted() {},
  methods: {
    async getData(orderInfo) {
      console.log("orderInfo", orderInfo);
      this.orderNo=orderInfo.orderNo;
      this.detail = orderInfo;
      let res=await OrderApi.getOrderGoods({orderNo: this.orderNo, goodLoc: 1});
      if(res.succ==0){
        this.$notifyError(res.error);
      }else{
        this.detailInfo = res.result
      }
      console.log(this.detailInfo,"==========")
      //格式化地址
      this.formatAddress()
      this.showFlag=true;
    },

    //格式化地址
    formatAddress() {
      let province = this.detail.province || "";
      let city = this.detail.city == "市辖区" ? "" : this.detail.city;
      let address = this.detail.address;
      this.detail.addressAll = province + city + this.detail.area + address;
    },

      //更新币种
    updateCurrency(currency) {
      this.currencyShow = currency;
    },

      //获取新增支付信息
    getAddPayList(val) {
      if (val) {
        this.detail.payRecords = val;
        console.log(this.detail.payRecords, "this.detail.payRecords");
      }
    },
    // 获取订单金额详情
    getAmountInfo(val) {
      if (val) {
        this.amountData = val;
        console.log(this.amountData, "amountData");
      }
    },

    //获取更新的卖家备注信息
    getSellerRemark(val) {
      if (val) {
        sessionStorage.setItem(this.detail.sellerRemark, val);
        this.detail.sellerRemark = val;
      }
    },

     //获取操作日志
    async getLogList() {
      this.isShowLogList = true;
      let res = await OrderApi.getOptLogList({
        orderNo: this.orderNo,
      });
      if (res.succ == 1) {
        if (res.code == 0) {
          this.logList = res.result;
        } else {
          return this.$notifyError(res.error);
        }
      } else {
        return this.$notifyError(res.error);
      }
    },

    //获取更新收货人信息
    getReceiveInfo(val) {
      if (val) {
        sessionStorage.setItem(this.detail.receiveName, val.receiveName);
        sessionStorage.setItem(this.detail.receivePhone, val.receivePhone);
        sessionStorage.setItem(this.detail.address, val.address);
        this.detail.receiveName = val.receiveName;
        this.detail.receivePhone = val.receivePhone;
        this.detail.address = val.address;
      }
      
    },



  },
  watch: {},
};
</script>


<style lang="scss">
.el-image-viewer__wrapper {
  z-index: 10000 !important;
}
</style>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
@mixin flex-mixin($direction, $align, $justify) {
  display: flex;
  flex-direction: $direction;
  align-items: $align;
  justify-content: $justify;
}
.w200 {
  width: 200px;
}

.edit_row_input {
  display: inline-block;
  font-size: 13px !important;
  .vs-input--input.small {
    font-size: 13px !important;
  }
}
.main-wrap {
  font-family: PingFangSC-Regular, PingFang SC;
  background-color: #fff;

  .top-title {
    @include flex-mixin(row, center, flex-start);
    height: 73px;
    color: #5e5873;
    font-size: 14px;
    border-bottom: 4px solid #f7f7fa;
    padding: 0 20px;
    position: relative;
    .yellow-text {
      color: #ff8d23;
    }
    .green-text {
      color: #2dc44b;
    }
    .red-text {
      color: #ff433d;
    }
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .log-btn {
      position: absolute;
      right: 15px;
      top: 24px;
      font-size: 15px;
      color: #3f90ff;
      cursor: pointer;
    }
  }
  .bot-content {
    // height: 927px;
    padding: 20px 20px 100px;
    width: 100%;
    .label {
      font-size: 18px;
      color: #5e5873;
      height: 73px;
      line-height: 73px;
      margin-top: 20px;
    }

    .detail-info {
      background-color: #f7f7fa;
      @include flex-mixin(row, stretch, flex-start);

      .item {
        width: 50%;
        min-height: 162px;
        border-right: 1px solid #ebe9f1;
        padding: 16px 20px;
        box-sizing: border-box;
        &.large {
          width: 100%;
        }
        .line {
          @include flex-mixin(row, center, space-between);
          &.end {
            @include flex-mixin(row, center, flex-end);
          }
          .btn {
            font-size: 14px;
            color: #3f90ff;
            margin-right: 10px;
            cursor: pointer;
            .feather-icon {
              width: 12px;
              height: 12px;
              vertical-align: middle;
            }
          }
        }
        .title {
          font-size: 16px;
          font-weight: 500;
          color: #5e5873;
        }
        .content {
          div {
            font-size: 13px;
            color: #5e5873;
            font-weight: 400;
            margin-top: 6px;
          }
        }
        .pay-list {
          display: flex;
          flex-wrap: wrap;
          .pay-content {
            width: 90%;
            display: flex;
            flex-wrap: wrap;
            margin-right: 20px;
            position: relative;
            div {
              margin-left: 10px;
              white-space: nowrap;
              &.width50 {
                width: 70px;
              }
              &.width20 {
                width: 20px;
              }
              &.width150 {
                width: 150px;
              }
              &.width200 {
                width: 200px;
              }
              &.width400 {
                min-width: 250px;
              }
            }
          }
          .pay-add {
            div {
              font-size: 12px;
              margin-top: 0px;
            }
          }
          .cancel-pay {
            cursor: pointer;
            color: #3f90ff;
            position: absolute;
            right: -100px;
          }
        }
      }
      .rt {
        border: none;
      }
    }

    .sku-info {
      margin-bottom: 20px;
    }
  }
  .btn-group {
    padding: 24px;
    /deep/ .vs-button {
      margin-right: 12px;
      padding: 9px 42px !important;
      border-radius: 5px;
    }
  }
}
.log-popup /deep/ .vs-popup {
  width: 700px;
}

.el-table {
  border: none;
  /deep/ .el-table__row {
    .cell {
      white-space: pre-wrap;
    }
  }
  &::before {
    border: none;
    height: 0;
  }
}
.dialog-box /deep/.el-drawer__header {
  margin-bottom: 10px !important;
  span {
    font-size: 16px;
    font-weight: 500;
    color: #3f90ff;
  }
}
</style>
